import { render, staticRenderFns } from "./auth-fail.vue?vue&type=template&id=49044294"
import script from "./auth-fail.vue?vue&type=script&lang=js"
export * from "./auth-fail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports